<template>
    <div style="display: flex">
        <SiderLayer />
        <div class="note__wrap">
            <div class="note__inner">
                <h2 class="h2 bold">마이노트</h2>
                <div class="note__content">
                    <q-card
                        class="note"
                        :onClick="
                            () => {
                                onClick('incorrectnote');
                            }
                        "
                        style="cursor: pointer"
                    >
                        <q-item class="my-card">
                            <q-item-section>
                                <p class="h2 bold line_height_52">오답노트</p>
                                <p class="b1 regular color_gray_600 line_height_45">오답 문제만 모아 다시 풀어 보세요.</p>
                            </q-item-section>
                            <q-card-actions>
                                <img class="img" src="@/assets/images/icon/img_mynote_wronganswernote_green.png" />
                            </q-card-actions>
                        </q-item>
                    </q-card>
                    <q-card
                        class="note"
                        :onClick="
                            () => {
                                onClick('killernote');
                            }
                        "
                        style="cursor: pointer"
                    >
                        <q-item class="my-card">
                            <q-item-section>
                                <p class="h2 bold line_height_52">심화노트</p>
                                <p class="b1 regular color_gray_600 line_height_45">상위 난이도 문제인 심화문제에 도전해 보세요.</p>
                            </q-item-section>
                            <q-card-actions>
                                <img class="img" src="@/assets/images/icon/img_mynote_killernote_green.png" />
                            </q-card-actions>
                        </q-item>
                    </q-card>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import { onMounted, getCurrentInstance } from 'vue';
import SiderLayer from '@/components/layouts/sider/siderLayer.vue';
import { historyBack } from '@/helpers/utils';
import { useRouter, useRoute } from 'vue-router';
import { monitoringLog } from '@/api/modules/monitoring';

const router = useRouter();
const route = useRoute();

const onClick = (pg) => {
    router.push('/' + pg);
};

onMounted(() => {
    let data = {
        menuName: route.path.split('/').join(''),
    };
    monitoringLog(data, (res) => {
        console.log('myNote monitoringLog API response ===', res);
    });
});
</script>

<style scoped lang="scss">
p {
    margin-bottom: 0;
}
.note__wrap {
    width: 90%;
}
.note__inner {
    padding: 3.2vw 2.3vw;
}
.note__inner h2 {
    margin-bottom: 6.6vh;
}
.note__content {
    @include display-flex;
    justify-content: space-between;
}
.note {
    width: calc((100% - 2vmin) / 2);
    border: 1px solid $color_gray_400;
    @include border-radius(1vw);
    background: $color_gray_100;
    box-shadow: inherit;
}
.my-card {
    justify-content: space-between;
    padding: 1.58vmin 0 1.58vmin 6.58vmin;
}

::v-deep {
    .q-item__section {
        flex: 0 0 auto;
    }
    .q-card__actions {
        width: 12vw;
        height: 12vw;
        padding: 0;
    }
    .q-card__actions img {
        width: 100%;
        height: 100%;
    }
}
/*
.note {
  border: 1px solid $gray_400;
  background: $gray_100;
  border-radius: 20px;
  width: calc(50% - 12px);
  float: left;

  .my-card {
    align-items: center;
    width: 100%;
    height: 24vh;
    padding: 1.67vmin 2.5vmin 1.67vmin 6.67vmin;
  }

  .img {
    width: 100%;
  }
}

.right {
  float: right;
}
::v-deep {
  .q-card__actions {
    width: 34%;
    max-width: 240px;
    padding: 0;
  }
}*/
</style>
